"use strict";

exports.__esModule = true;
exports.ReportThumbnail = ReportThumbnail;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Theme = require("../../Theme");
var _ActivitySummary = _interopRequireDefault(require("../../../../assets/ReportThumbnails/ActivitySummary.png"));
var _PerformanceGrid = _interopRequireDefault(require("../../../../assets/ReportThumbnails/PerformanceGrid.png"));
var _HourlyActivitySummary = _interopRequireDefault(require("../../../../assets/ReportThumbnails/HourlyActivitySummary.png"));
var _OperatorMetrics = _interopRequireDefault(require("../../../../assets/ReportThumbnails/OperatorMetrics.png"));
var _PartMetrics = _interopRequireDefault(require("../../../../assets/ReportThumbnails/PartMetrics.png"));
var _ToolPerformance = _interopRequireDefault(require("../../../../assets/ReportThumbnails/ToolPerformance.png"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DefaultThumbnail = function DefaultThumbnail() {
  return /*#__PURE__*/_react["default"].createElement("rect", {
    x: 0,
    y: 0,
    width: 1024,
    height: 768,
    fill: "#fff"
  });
};
var ThumbnailSVGWrapper = _styledComponents["default"].svg.withConfig({
  displayName: "ReportThumbnail__ThumbnailSVGWrapper",
  componentId: "sc-bx7vl4-0"
})(["border:solid 1px ", ";"], (0, _Theme.selectable)("ThumbnailListItemBorderColor"));
var ThumbnailImgWrapper = _styledComponents["default"].img.withConfig({
  displayName: "ReportThumbnail__ThumbnailImgWrapper",
  componentId: "sc-bx7vl4-1"
})(["border:solid 1px ", ";"], (0, _Theme.selectable)("ThumbnailListItemBorderColor"));
var mapping = {
  activitySummary: _ActivitySummary["default"],
  performanceGrid: _PerformanceGrid["default"],
  toolPerformance: _ToolPerformance["default"],
  hourlyActivitySummary: _HourlyActivitySummary["default"],
  partMetrics: _PartMetrics["default"],
  operatorMetrics: _OperatorMetrics["default"]
};
function ReportThumbnail(props) {
  var _props$width = props.width,
    width = _props$width === void 0 ? 1024 : _props$width,
    _props$height = props.height,
    height = _props$height === void 0 ? 768 : _props$height,
    reportKey = props.reportKey;
  var Thumbnail = mapping[reportKey] || DefaultThumbnail;
  if (typeof Thumbnail === "string") {
    return /*#__PURE__*/_react["default"].createElement(ThumbnailImgWrapper, {
      width: width,
      height: height,
      src: Thumbnail,
      alt: "report"
    });
  }
  return /*#__PURE__*/_react["default"].createElement(ThumbnailSVGWrapper, {
    width: width,
    height: height,
    viewBox: "0 0 1024 768"
  }, /*#__PURE__*/_react["default"].createElement(Thumbnail, null));
}